module.exports = __webpack_public_path__ + "media/maradonaFrases.d331d534.mp4";